// extracted by mini-css-extract-plugin
module.exports = {"line":"SortableAllowancesTable__line--tSZ2K","icon":"SortableAllowancesTable__icon--2HWvX","through":"SortableAllowancesTable__through--1KpfW"};